export const roundMoney = (value: number) => Math.round((value || 0) * 100) / 100

export const parseConditionToOffsets = (name?: string): number[] => {
  if (!name) return [0]
  const normalized = name.trim().toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
  if (normalized.includes('vista')) return [0]
  const offsets = name
    .split('/')
    .map(part => parseInt(part.replace(/\D/g, ''), 10))
    .filter(num => !isNaN(num))
  return offsets.length ? offsets : [0]
}

export const addDays = (isoDate: string | undefined, days: number): string => {
  const base = isoDate ? new Date(`${isoDate}T00:00:00`) : new Date()
  if (isNaN(base.getTime())) return ''
  base.setDate(base.getDate() + days)
  return base.toISOString().slice(0, 10)
}

/** O ajuste de centavos da divisão vai na última parcela. */
export const buildInstallments = (total: number, offsets: number[], baseDate?: string) => {
  const count = offsets.length || 1
  const base = roundMoney(total / count)
  return offsets.map((offset, index) => {
    const isLast = index === count - 1
    const valor = isLast ? roundMoney(total - base * (count - 1)) : base
    return {
      numero: index + 1,
      valor,
      vencimento: addDays(baseDate, offset),
      comissaoAtiva: false,
      comissaoPercentual: undefined,
      diasOffset: offset,
    }
  })
}
